export const paragraphStyles = "text-muted leading-relaxed";
export const header1Styles =
  "font-display text-3xl md:text-4xl font-semibold tracking-tight text-ink mb-4";
export const header2Styles =
  "font-display text-2xl font-semibold tracking-tight text-accent mb-3";
